import _implicitStylesheets from "./moreFromThisProviderV2.css";
import _implicitScopedStylesheets from "./moreFromThisProviderV2.scoped.css?scoped=true";
import _wdsListingTile from "wds/listingTile";
import _listingRecommendationCarousel from "listing/recommendationCarousel";
import _wdsSpinner from "wds/spinner";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "recommendation-card": true
};
const stc1 = {
  key: 3
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, k: api_key, c: api_custom_element, h: api_element, i: api_iterator} = $api;
  const {_m0, _m1} = $ctx;
  return [$cmp.displayMoreFromThisProvider ? api_custom_element("listing-recommendation-carousel", _listingRecommendationCarousel, {
    props: {
      "title": $cmp.title,
      "itemCount": $cmp.providerListingCount,
      "previousLabel": $cmp.previousLabel,
      "nextLabel": $cmp.nextLabel
    },
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics)),
      "trackscroll": _m1 || ($ctx._m1 = api_bind($cmp.handleTrackScroll))
    }
  }, api_iterator($cmp.providerListings, function (tile, index) {
    return api_element("li", {
      slotAssignment: "cards",
      classMap: stc0,
      key: api_key(1, tile.id)
    }, [api_custom_element("wds-listing-tile", _wdsListingTile, {
      props: {
        "role": "group",
        "variant": "stack",
        "positionIndex": index,
        "props": tile
      },
      key: 2
    })]);
  })) : null, $cmp.isLoading ? api_custom_element("wds-spinner", _wdsSpinner, stc1) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1bdfic41v20";
tmpl.legacyStylesheetToken = "undefined-_moreFromThisProviderV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
